import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

export default css`
    background: ${getBaseTheme().colors.area.default.backgroundColor};
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1000;
`;
